"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var component_1 = require("./component");
var core_1 = require("../../core");
var StaticComponent = /** @class */ (function (_super) {
    __extends(StaticComponent, _super);
    function StaticComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // prevent re-rendering after the initial render
    // to keep VDOM from syncing the DOM. Thus the component becomes static
    // and external JavaScript libraries can prosper
    StaticComponent.prototype.shouldRender = function () {
        return !this.INTERNAL.notInitialRender;
    };
    return StaticComponent;
}(component_1.Component));
exports.StaticComponent = StaticComponent;
core_1.st.staticComponent = StaticComponent;
//# sourceMappingURL=static-component.js.map